import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { GET_BANK_ACCOUNTS, GET_BANK_ACCOUNT_BY_ID } from '../graphql/queries/bank.query';

@Injectable({
  providedIn: 'root'
})
export class BankService {

  constructor(private apollo: Apollo) { }

  fetchBankAccounts(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_BANK_ACCOUNTS,
        variables: { search },
        fetchPolicy: 'network-only'
      })
      .valueChanges.pipe(
        map((result) => result.data?.bankAccounts || [])
      );
  }

  getBankAccountById(id: number): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_BANK_ACCOUNT_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only'
      })
      .valueChanges.pipe(
        map((result) => result.data?.bankAccount || [])
      );
  }
} 